import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef } from "vue";
const _hoisted_1 = { class: "layout-row items-center flex-grow justify-center md:justify-between max-w-[1044px]" };
const _hoisted_2 = {
    key: 0,
    class: "flex h-[504px] w-[492px] justify-center items-center"
};
const _hoisted_3 = {
    key: 1,
    class: "px-md absolute left-0 right-0 top-sm"
};
const _hoisted_4 = {
    key: 0,
    class: "w-full layout-column gap-md"
};
import { OrButtonV3, OrNotificationV3, useResponsive, } from '@onereach/ui-components';
import { load as loadRecaptcha, getInstance as getCaptchaInstance } from 'recaptcha-v3';
import { ref, watch, onBeforeMount, onBeforeUnmount, } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLoginForm } from '@/components/Auth/composables/useLoginForm';
import { useLoginPage } from '@/components/Auth/composables/useLoginPage';
import { useMfaForm } from '@/components/Auth/composables/useMfaForm';
import { useMfaRecoveryModal } from '@/components/Auth/composables/useMfaRecoveryModal';
import GoogleLogin from '@/components/Auth/GoogleLogin.vue';
import LoginForm from '@/components/Auth/LoginForm.vue';
import MFAForm from '@/components/Auth/MFAForm.vue';
import MFARecoveryModal from '@/components/Auth/MFARecoveryModal.vue';
import PasswordRecoveryModal from '@/components/Auth/PasswordRecoveryModal.vue';
import { ErrorActions } from '@/components/Auth/types/errors';
import OrAnimationLogo from '@/components/OrAnimationLogo/OrAnimationLogo.vue';
import { useAuth } from '@/composables/useAuth';
import useI18n from '@/composables/useI18n';
import config from '@/config';
import LoginContainer from '@/layouts/LoginContainer.vue';
import { useAuthStore } from '@/stores/auth/auth';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginPage',
    props: {
        shouldRedirectToDefaultProvider: { type: Boolean, default: false },
        showGoogleSSo: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const route = useRoute();
        const router = useRouter();
        const authStore = useAuthStore();
        const { translate } = useI18n();
        const { isDesktop } = useResponsive();
        // Captcha logic
        const showCaptchaV2Checkbox = ref(false);
        const captchaWidgetId = ref(null);
        const captchaV2Checkbox = ref(null);
        const getCaptchaToken = async (captchaV2CheckboxToken) => {
            let captchaToken;
            if (typeof captchaV2CheckboxToken === 'string') {
                captchaToken = captchaV2CheckboxToken;
            }
            else {
                const recaptcha = await loadRecaptcha(config.GOOGLE_CAPTCHA_SITE_KEY_V3);
                captchaToken = await recaptcha.execute('signin');
            }
            return captchaToken;
        };
        const renderCapthcaV2Checkbox = async () => {
            showCaptchaV2Checkbox.value = true;
            // eslint-disable-next-line no-undef
            if (grecaptcha && !captchaWidgetId.value) {
                const captchaToken = await new Promise(resolve => {
                    // eslint-disable-next-line no-undef
                    captchaWidgetId.value = grecaptcha.render(captchaV2Checkbox.value, {
                        sitekey: config.GOOGLE_CAPTCHA_SITE_KEY_V2_CHECKBOX,
                        // @ts-ignore
                        callback: resolve,
                    });
                });
                await submit(captchaToken);
                showCaptchaV2Checkbox.value = false;
            }
        };
        // LoginPage logic
        const { loginIframeLogic, externalProviders, googleSSOLoading, accountData, isExpired, closeExpiredNotification, } = useLoginPage();
        const { initiateExternalLogin, authorizeRedirect, redirectToDefaultProviderIfExists, } = useAuth();
        watch(() => authStore.authorized, (value) => {
            if (value) {
                authorizeRedirect('user-action').catch(() => isLoadingLogin.value = false);
            }
        });
        const processErrorAction = (action) => {
            if (action === ErrorActions.Expired) {
                const currentUrl = window.location.origin;
                const redirectUrl = `${currentUrl}?expired`;
                window.location.href = redirectUrl;
                return;
            }
            else if (action === ErrorActions.RenderCaptcha) {
                renderCapthcaV2Checkbox();
            }
        };
        const listenIframe = (event) => {
            loginIframeLogic(event, {
                keepLoggedIn,
                accountData,
            });
        };
        // Components composables
        const { password, username, expiredUsername, keepLoggedIn, loginError, isLoadingLogin, submit, readonlyLogin, } = useLoginForm(accountData, getCaptchaToken, processErrorAction);
        const { verificationCode, mfaError, isLoadingMfa, logout, pasteMfaFromBuffer, submitMfa, } = useMfaForm(accountData, getCaptchaToken, processErrorAction, username, password, keepLoggedIn);
        const { isLoadingMfaRecovery, isOpenRecovery2fa, recoveryCode, recoveryError, submitMfaRecovery, toogleOpenRecovery2fa, } = useMfaRecoveryModal(accountData, getCaptchaToken, processErrorAction, username, password, keepLoggedIn);
        const resetPasswordModal = ref(null);
        const showForgotPopup = () => {
            var _a;
            (_a = resetPasswordModal.value) === null || _a === void 0 ? void 0 : _a.open();
        };
        // External providers && SSO logic
        const isGoogleLogin = config.GOOGLE_LOGIN || props.showGoogleSSo;
        if (props.shouldRedirectToDefaultProvider) {
            redirectToDefaultProviderIfExists(authStore.redirectPath);
        }
        onBeforeMount(async () => {
            window.addEventListener('message', listenIframe);
            await loadRecaptcha(config.GOOGLE_CAPTCHA_SITE_KEY_V3);
            const isExpiredQuery = route.query.expired === null;
            if (isExpiredQuery) {
                if (expiredUsername.value) {
                    username.value = expiredUsername.value;
                    router.replace({ query: {} });
                    isExpired.value = isExpiredQuery;
                    readonlyLogin.value = true;
                }
                else {
                    isExpired.value = true;
                    router.replace({ query: {} });
                }
            }
        });
        onBeforeUnmount(() => {
            var _a;
            if (config.HELPER_BOT_ENABLED) {
                // Show chat on pages except login
                const chat = document.querySelector('.or-rwc');
                if (chat) {
                    chat.style.display = 'block';
                }
            }
            (_a = getCaptchaInstance()) === null || _a === void 0 ? void 0 : _a.hideBadge();
            window.removeEventListener('message', listenIframe);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(LoginContainer, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (_unref(isDesktop))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(OrAnimationLogo)
                            ]))
                            : _createCommentVNode("", true),
                        (_unref(isExpired))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_unref(OrNotificationV3), {
                                    class: "sm:max-w-[768px] mx-auto",
                                    onClose: _unref(closeExpiredNotification)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)('login.login.Due to inactivity, your session has expired')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["onClose"])
                            ]))
                            : _createCommentVNode("", true),
                        (!_unref(authStore).twoFactorCheck)
                            ? (_openBlock(), _createBlock(LoginForm, {
                                key: 2,
                                "keep-logged-in": _unref(keepLoggedIn),
                                "onUpdate:keepLoggedIn": _cache[0] || (_cache[0] = ($event) => (_isRef(keepLoggedIn) ? (keepLoggedIn).value = $event : null)),
                                password: _unref(password),
                                "onUpdate:password": _cache[1] || (_cache[1] = ($event) => (_isRef(password) ? (password).value = $event : null)),
                                username: _unref(username),
                                "onUpdate:username": _cache[2] || (_cache[2] = ($event) => (_isRef(username) ? (username).value = $event : null)),
                                "is-loading": _unref(isLoadingLogin),
                                "readonly-login": _unref(readonlyLogin),
                                "service-error": _unref(loginError),
                                onSubmit: _unref(submit),
                                onShowForgotPopup: showForgotPopup
                            }, {
                                captcha: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", {
                                            ref_key: "captchaV2Checkbox",
                                            ref: captchaV2Checkbox,
                                            class: "flex justify-center mb-md+"
                                        }, null, 512)
                                    ], 512), [
                                        [_vShow, showCaptchaV2Checkbox.value]
                                    ])
                                ]),
                                "google-login": _withCtx(() => [
                                    (_unref(isGoogleLogin))
                                        ? (_openBlock(), _createBlock(GoogleLogin, {
                                            key: 0,
                                            loading: _unref(googleSSOLoading),
                                            "button-type": "outlined",
                                            label: _unref(translate)('login.login.Sign in with Google')
                                        }, null, 8, ["loading", "label"]))
                                        : _createCommentVNode("", true)
                                ]),
                                "external-providers": _withCtx(() => [
                                    (_unref(externalProviders).length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(externalProviders), (provider) => {
                                                return (_openBlock(), _createBlock(_unref(OrButtonV3), {
                                                    key: provider.name,
                                                    loading: _unref(isLoadingLogin),
                                                    variant: "outlined",
                                                    onClick: ($event) => (_unref(initiateExternalLogin)(provider.name, _unref(authStore).redirectPath))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(translate)('login.login.Sign in with', { providerName: provider.name })), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["loading", "onClick"]));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["keep-logged-in", "password", "username", "is-loading", "readonly-login", "service-error", "onSubmit"]))
                            : (_openBlock(), _createBlock(MFAForm, {
                                key: 3,
                                "verification-code": _unref(verificationCode),
                                "onUpdate:verificationCode": _cache[3] || (_cache[3] = ($event) => (_isRef(verificationCode) ? (verificationCode).value = $event : null)),
                                username: _unref(username),
                                "is-loading": _unref(isLoadingMfa) || _unref(googleSSOLoading),
                                error: _unref(mfaError),
                                onSubmit: _unref(submitMfa),
                                onToogleOpenRecovery2fa: _cache[4] || (_cache[4] = ($event) => (_unref(toogleOpenRecovery2fa)(true))),
                                onPasteFromBuffer: _unref(pasteMfaFromBuffer),
                                onLogout: _unref(logout)
                            }, {
                                captcha: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", null, [
                                        _createElementVNode("div", {
                                            ref_key: "captchaV2Checkbox",
                                            ref: captchaV2Checkbox,
                                            class: "flex justify-center mb-md+"
                                        }, null, 512)
                                    ], 512), [
                                        [_vShow, showCaptchaV2Checkbox.value]
                                    ])
                                ]),
                                _: 1
                            }, 8, ["verification-code", "username", "is-loading", "error", "onSubmit", "onPasteFromBuffer", "onLogout"]))
                    ]),
                    _createVNode(MFARecoveryModal, {
                        modelValue: _unref(recoveryCode),
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_isRef(recoveryCode) ? (recoveryCode).value = $event : null)),
                        "is-loading": _unref(isLoadingMfaRecovery) || _unref(googleSSOLoading),
                        "recovery-error": _unref(recoveryError),
                        "is-open-recovery2fa": _unref(isOpenRecovery2fa),
                        onToogleOpenRecovery2fa: _unref(toogleOpenRecovery2fa),
                        onSubmit: _unref(submitMfaRecovery)
                    }, null, 8, ["modelValue", "is-loading", "recovery-error", "is-open-recovery2fa", "onToogleOpenRecovery2fa", "onSubmit"]),
                    _createVNode(PasswordRecoveryModal, {
                        ref_key: "resetPasswordModal",
                        ref: resetPasswordModal,
                        "redirect-path": _unref(authStore).redirectPath
                    }, null, 8, ["redirect-path"])
                ]),
                _: 1
            }));
        };
    }
});
